import { DatabaseZap } from "lucide-react";
import { useApi } from "../../lib/api";

export default function FallbackDbBanner({ isAdmin }) {
  const { data } = useApi(isAdmin ? "/admin/system" : null);
  if (data?.database !== "sqlite") return null;
  return (
    <div role="alert" className="no-print flex items-start gap-3 border-b border-red-800 bg-red-950/80 px-4 md:px-6 py-3 text-sm text-red-100" data-testid="fallback-db-banner">
      <DatabaseZap className="h-5 w-5 shrink-0 text-red-400 mt-0.5" />
      <div>
        <span className="font-semibold">Database di riserva attivo.</span>{" "}
        Il database principale non è raggiungibile: le modifiche fatte ora non vengono salvate in modo permanente e andranno perse al prossimo riavvio.
      </div>
    </div>
  );
}
